"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreadcrumbsContext = exports.DynamicBreadcrumbsProvider = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DynamicBreadcrumbsContextConst = /*#__PURE__*/(0, _react.createContext)({});

/**
 * Breadcrumbs provider
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
var DynamicBreadcrumbsProvider = function DynamicBreadcrumbsProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      breadcrumbs = _useState2[0],
      setBreadcrumbs = _useState2[1];

  var addBreadcrumb = (0, _react.useCallback)(function (breadcrumb) {
    setBreadcrumbs(function (prevBreadcrumbs) {
      return [].concat((0, _toConsumableArray2["default"])(prevBreadcrumbs), [breadcrumb]);
    });
  }, []);
  var removeBreadcrumb = (0, _react.useCallback)(function (key) {
    setBreadcrumbs(function (prevBreadcrumbs) {
      var breadcrumbIndex = prevBreadcrumbs.findIndex(function (breadcrumb) {
        return breadcrumb.key === key;
      });
      return prevBreadcrumbs.slice(0, breadcrumbIndex);
    });
  }, []);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      breadcrumbs: breadcrumbs,
      addBreadcrumb: addBreadcrumb,
      removeBreadcrumb: removeBreadcrumb
    };
  }, [breadcrumbs, addBreadcrumb, removeBreadcrumb]);
  return /*#__PURE__*/_react["default"].createElement(DynamicBreadcrumbsContextConst.Provider, {
    value: contextValue
  }, children);
};

exports.DynamicBreadcrumbsProvider = DynamicBreadcrumbsProvider;
DynamicBreadcrumbsProvider.propTypes = {
  children: _propTypes["default"].node.isRequired
};
/**
 * Hook that returns dynamic breadcrumbs context.
 *
 * @returns {IDynamicBreadcrumbsContext}
 */

var useBreadcrumbsContext = function useBreadcrumbsContext() {
  return (0, _react.useContext)(DynamicBreadcrumbsContextConst);
};

exports.useBreadcrumbsContext = useBreadcrumbsContext;